import { createSlice } from '@reduxjs/toolkit';

import { SlicePayload, UntypedObject } from '@/types';

export type CustomizationState = UntypedObject;

export const initialState: CustomizationState = {
};

type CustomizationStepPayload = {
  id: string;
  step: any;
  options?: UntypedObject;
  isNextStep?: boolean;
}

const customization = createSlice({
  name: 'customization',
  initialState,
  reducers: {
    changeBoxCustomization: (
      _state,
      _action: SlicePayload<{
        boxId: string, customization: UntypedObject, customizationQt: number,
        redirection?: CustomizationStepPayload, isGetCart: boolean
      }>
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    ) => {
    },

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    changeBoxCustomizationSuccess: (_state, _action: SlicePayload<{ content: UntypedObject }>) => {
    },

    changeCustomizationStep: (
      _state,
      _action: SlicePayload<CustomizationStepPayload>
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    ) => {
    },

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    changeCustomizationStepSuccess: () => {
    },

    customizationNextStep: (
      _state,
      _action: SlicePayload<CustomizationStepPayload & {
        initialCustomization: UntypedObject,
        customization: UntypedObject,
        customizationQt: number
      }>
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    ) => {
    },

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    customizationPrevStep: (_state, _action: SlicePayload<CustomizationStepPayload>) => {
    },

    updateCustomizationAttribute: (
      _state,
      _action: SlicePayload<{
        id: string, attributeName: string, newValue: any, redirection?: CustomizationStepPayload
      }>
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    ) => {
    }
  }
});

export const {
  changeBoxCustomization, changeBoxCustomizationSuccess,
  changeCustomizationStep, changeCustomizationStepSuccess,
  customizationNextStep, customizationPrevStep,
  updateCustomizationAttribute
} = customization.actions;

export default customization.reducer;
